import { render, staticRenderFns } from "./Atas.vue?vue&type=template&id=f3ca2a66&scoped=true&"
import script from "./Atas.vue?vue&type=script&lang=js&"
export * from "./Atas.vue?vue&type=script&lang=js&"
import style0 from "./Atas.vue?vue&type=style&index=0&id=f3ca2a66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ca2a66",
  null
  
)

export default component.exports